
let ghostItemsInCart = [];
let cartMenuOpen = false;

let localStorageCartKey = "cartMenuOpenStatus";

function fixPage()
{
    updateCartSideSubTotal();
    toggleCartEmptyState();
    fixCartMenuHeight();
}

function loadItemIntoGhost(productId)
{
    let QTYToSendCS = document.getElementById(`CartSideQtyJsRef${productId}`).value;

    ghostItemsInCart[productId] = { productId:productId, QTY:QTYToSendCS }
}

function addNewGhostProduct(productId, ghostItemId, ghostItemImgSrc, ghostItemTitle, ghostItemPrice, ghostItemURL)
{
    if(ghostItemsInCart[productId] != undefined)
    {
        // In Cart Already
        let CartQTYCounter = document.getElementById(`CartSideQtyJsRef${productId}`);
        let QTYToAdd = 1;
        
        let newQTY = parseInt(ghostItemsInCart[productId].QTY) + parseInt(QTYToAdd);

        CartQTYCounter.value = newQTY;
        ghostItemsInCart[productId].QTY = newQTY;

    }else
    {
        // Make A New Product
        let ghostItemHLD = document.getElementById('cartSideGhostItems');
        
        // Jump To Top
        let cartSideItemHld = document.getElementsByClassName('cartSideItemHld')[0];
        cartSideItemHld.scrollTop = 0;

        let ghostItemQTY = 1;
        try
        {
            ghostItemQTY = document.getElementById("proItemQtyJsRef" + productId).value;    
        } catch (e){}
        
        let cartItemHldJS = document.createElement('div');
        cartItemHldJS.classList.add('cartSideItem');
        cartItemHldJS.classList.add(`cartSideItem${productId}`);
        cartItemHldJS.innerHTML = 
        `
            <div class="cartSideItemIMG"><a href="${ghostItemURL}" aria-label="${ghostItemTitle}"><img title="${ghostItemTitle}" src="${ghostItemImgSrc}" alt="${ghostItemTitle}"></a></div>
            
                <div class="cartSideItemInfo">
                <p class="cartSideItemPrice">Price: ${ghostItemPrice}</p>

                <div class="cartSideTrashNQTY">
                    <div class="cartSideTrashcan">
                    <button onclick="removeItemFromCartSide(${productId}, ${ghostItemId})">
                        <svg version="1.1" xmlns="https://www.w3.org/2000/svg" xmlns:xlink="https://www.w3.org/1999/xlink" viewBox="0, 0, 400,400">
                        <g transform="translate(-110, -178.5) scale(1.58)">
                            <path d="M168.894 128.386 C 164.278 129.502,162.616 132.498,162.606 139.721 L 162.600 144.843 199.992 144.810 C 220.557 144.791,237.537 144.623,237.724 144.436 C 237.911 144.249,238.004 141.676,237.932 138.717 C 237.775 132.332,237.121 130.841,233.734 129.160 L 231.800 128.200 201.000 128.135 C 184.060 128.099,169.612 128.212,168.894 128.386 M150.092 199.201 C 147.785 200.607,147.806 200.364,148.340 219.721 C 148.799 236.340,148.979 242.398,149.987 275.400 C 150.209 282.660,150.579 294.900,150.810 302.600 C 152.003 342.387,151.864 340.696,154.024 341.812 C 156.914 343.307,162.374 342.236,163.661 339.921 C 164.344 338.694,164.135 326.024,162.801 287.600 C 162.583 281.330,162.223 270.800,162.000 264.200 C 161.778 257.600,161.420 247.160,161.206 241.000 C 160.991 234.840,160.621 223.860,160.382 216.600 C 159.900 201.920,159.664 200.515,157.454 199.168 C 155.708 198.103,151.864 198.120,150.092 199.201 M197.248 198.784 C 195.136 199.309,193.985 200.069,193.304 201.386 C 192.409 203.116,192.515 337.489,193.413 339.225 C 194.936 342.169,202.215 342.362,204.606 339.520 L 205.600 338.339 205.591 270.869 C 205.583 205.455,205.559 203.349,204.823 201.727 C 203.681 199.211,200.499 197.975,197.248 198.784 M241.015 199.118 C 237.147 200.448,237.710 192.042,235.593 280.000 C 235.368 289.350,235.007 303.487,234.792 311.415 C 234.191 333.527,234.243 337.137,235.182 338.678 C 237.412 342.335,243.487 342.329,246.094 338.668 C 247.080 337.284,247.060 337.691,247.984 300.200 C 248.229 290.300,248.597 276.710,248.802 270.000 C 249.008 263.290,249.373 250.420,249.612 241.400 C 249.852 232.380,250.201 220.235,250.387 214.411 C 250.701 204.588,250.673 203.720,250.002 202.411 C 248.175 198.851,245.084 197.718,241.015 199.118 " stroke="none" fill="transparent" fill-rule="evenodd"></path>
                            <path class="cartSideTrashCanPath" d="M168.400 113.597 C 168.070 113.812,167.136 113.991,166.324 113.994 C 165.512 113.997,164.736 114.180,164.600 114.400 C 164.464 114.620,164.001 114.800,163.571 114.800 C 163.141 114.800,162.477 114.960,162.095 115.156 C 161.713 115.352,160.500 115.933,159.400 116.448 C 156.304 117.895,152.031 122.392,150.323 126.000 C 148.194 130.497,148.000 131.412,148.000 136.964 L 148.000 142.071 133.300 141.936 C 119.881 141.812,118.391 141.865,116.200 142.542 C 110.596 144.274,106.805 146.942,105.249 150.248 C 104.951 150.881,104.554 151.702,104.368 152.072 C 104.181 152.441,103.977 155.951,103.914 159.872 L 103.800 167.000 104.907 168.630 C 105.516 169.527,106.710 170.652,107.561 171.130 L 109.109 172.000 199.562 172.000 L 290.016 172.000 291.541 171.037 C 295.010 168.847,295.200 168.336,295.200 161.188 C 295.200 154.654,295.137 154.308,293.251 150.454 C 291.629 147.140,286.650 143.200,284.084 143.200 C 283.686 143.200,283.180 143.020,282.959 142.799 C 282.161 142.001,276.370 141.624,264.700 141.612 L 252.800 141.600 252.800 137.328 C 252.800 132.306,252.576 131.421,249.776 125.400 C 247.918 121.404,243.799 117.121,240.398 115.648 C 236.962 114.159,236.699 114.067,235.000 113.763 C 232.439 113.304,169.093 113.147,168.400 113.597 M233.734 129.160 C 237.121 130.841,237.775 132.332,237.932 138.717 C 238.004 141.676,237.911 144.249,237.724 144.436 C 237.537 144.623,220.557 144.791,199.992 144.810 L 162.600 144.843 162.606 139.721 C 162.614 133.673,163.362 131.499,166.043 129.724 C 168.529 128.079,168.793 128.067,201.000 128.135 L 231.800 128.200 233.734 129.160 M117.591 179.348 C 112.307 180.669,110.963 185.028,112.458 196.000 C 112.683 197.650,113.032 201.655,113.233 204.900 C 113.974 216.814,115.272 235.612,117.197 262.300 C 117.721 269.564,118.271 277.239,118.796 284.600 C 119.446 293.719,119.940 300.460,120.379 306.200 C 120.598 309.060,120.945 313.920,121.150 317.000 C 121.869 327.770,122.413 334.206,122.671 335.000 C 122.815 335.440,123.069 338.230,123.236 341.200 C 123.584 347.370,123.926 350.035,124.441 350.580 C 124.638 350.789,124.800 351.376,124.800 351.885 C 124.800 352.394,124.959 353.123,125.152 353.505 C 125.346 353.887,126.189 355.640,127.025 357.400 C 129.429 362.459,133.888 366.475,139.061 368.239 C 141.215 368.973,255.610 368.877,258.071 368.139 C 269.892 364.591,274.255 357.860,275.142 341.800 C 275.301 338.940,275.551 336.330,275.698 336.000 C 275.846 335.670,276.171 332.340,276.421 328.600 C 276.671 324.860,277.050 319.730,277.264 317.200 C 277.701 312.032,278.224 304.998,278.811 296.400 C 279.028 293.210,279.392 287.990,279.620 284.800 C 280.297 275.300,280.766 268.567,281.206 262.000 C 281.435 258.590,281.798 253.280,282.014 250.200 C 283.777 225.017,283.980 221.869,284.227 215.800 C 284.353 212.720,284.623 210.029,284.828 209.820 C 285.033 209.611,285.200 207.034,285.200 204.094 C 285.200 201.153,285.385 198.402,285.610 197.981 C 286.435 196.439,286.603 184.748,285.823 183.105 C 284.903 181.167,283.079 179.862,280.469 179.277 C 277.496 178.611,120.265 178.679,117.591 179.348 M157.454 199.168 C 159.664 200.515,159.900 201.920,160.382 216.600 C 160.621 223.860,160.991 234.840,161.206 241.000 C 161.420 247.160,161.778 257.600,162.000 264.200 C 162.223 270.800,162.583 281.330,162.801 287.600 C 164.135 326.024,164.344 338.694,163.661 339.921 C 162.374 342.236,156.914 343.307,154.024 341.812 C 151.864 340.696,152.003 342.387,150.810 302.600 C 150.579 294.900,150.209 282.660,149.987 275.400 C 147.494 193.818,147.484 200.790,150.092 199.201 C 151.864 198.120,155.708 198.103,157.454 199.168 M202.873 199.438 C 205.790 200.946,205.581 195.464,205.591 270.869 L 205.600 338.339 204.606 339.520 C 202.215 342.362,194.936 342.169,193.413 339.225 C 192.515 337.489,192.409 203.116,193.304 201.386 C 194.692 198.701,199.541 197.715,202.873 199.438 M246.040 198.855 C 250.398 200.315,250.792 201.727,250.387 214.411 C 250.201 220.235,249.852 232.380,249.612 241.400 C 249.373 250.420,249.008 263.290,248.802 270.000 C 248.597 276.710,248.229 290.300,247.984 300.200 C 247.060 337.691,247.080 337.284,246.094 338.668 C 243.487 342.329,237.412 342.335,235.182 338.678 C 234.243 337.137,234.191 333.527,234.792 311.415 C 235.007 303.487,235.368 289.350,235.593 280.000 C 237.405 204.727,237.482 202.477,238.309 201.047 C 239.478 199.027,243.309 197.941,246.040 198.855 " stroke="none" fill="var(--mainColor)" fill-rule="evenodd"></path>
                        </g>
                        </svg>
                    </button>
                    </div>

                    <div class="cartSideItemQTY">
                    <div class="proItemQtyHolder">
                        <input onchange="changeQTYInCartSide(event, ${productId}, ${ghostItemId})" class="INP_QTY" id="CartSideQtyJsRef${productId}" type="number" name="quantity" value="${ghostItemQTY}" min="1" max="99" data-inc="1">
                        <div class="proItemQtyBackground cartSideQtyBackground"></div>
                    </div>
                    </div>
                </div>
            </div>
        `;

        ghostItemHLD.insertBefore(cartItemHldJS, ghostItemHLD.firstChild);
        customQuantity();

        ghostItemQTY = parseInt(ghostItemQTY);

        ghostItemsInCart[productId] = {productId:productId, QTY:ghostItemQTY};
        
        try 
        {
            document.getElementsByClassName('emptyCartText')[0].style.display = 'none';
        } catch (e){}
    }

    toggleCartEmptyState();
    updateCartSideSubTotal();
    fixCartMenuHeight();
}

function removeAllCartUser()
{    
    fetch('/cart/clear.js', {
    method: 'POST'
    })
    .then(() => {
        window.location.reload();
    });
}

function removeProductFromArray(prodId)
{
    // Archive Old Array without product id
    let newArrayWithoutProduct = [];

    Object.keys(ghostItemsInCart).forEach(ElmKey =>
    {
        if(ElmKey != prodId)
        {
            newArrayWithoutProduct.push({ productId:ghostItemsInCart[ElmKey].productId, QTY:ghostItemsInCart[ElmKey].QTY });
        }
    });
    
    // Sync New Array To Old Array
    ghostItemsInCart = [];

    for (let i = 0; i < newArrayWithoutProduct.length; i++) 
    {
        let workingProductId = newArrayWithoutProduct[i].productId;
        let workingQTY = newArrayWithoutProduct[i].QTY;

        ghostItemsInCart[workingProductId] = { productId: workingProductId, QTY: workingQTY};   
    }    
}

function fixCartMenuQTY(productId, QTY)
{
    document.getElementById(`CartSideQtyJsRef${productId}`).value = QTY;
}

function forceCloseCartMenu(fromToggleCart = false)
{
    const cartBody = document.getElementById('cartBody');
    const MOTO = document.getElementById('MOTOBanner');

    cartBody.style.display = 'none';
    MOTO.style.top = "-50px";

    try {
        let shopfyEmbed = document.querySelectorAll('shopify-forms-embed')[0];
        let newsLetterSignUpHld = shopfyEmbed.shadowRoot.getElementById('app-embed');

        newsLetterSignUpHld.style.right = 'var(--newsLetterSignUpHldRight)';
    } catch (e){}

    let mainMenuHld = document.getElementById('MainContentHolder');
    mainMenuHld.style.removeProperty('position');
    mainMenuHld.style.removeProperty('top');

    localStorage.setItem(localStorageCartKey, "Close");

    if(cartMenuOpen)
    {
        document.body.classList.toggle('openCartSidemenu');
        cartMenuOpen = false;
    }

    if(!fromToggleCart)
        fixPage();
}

function toggleCartMenu()
{
    let canOpenCartMenu = true;
    cartMenuOpen = cartMenuOpen ? false : true;

    if(window.location.pathname == "/cart")
    {
        canOpenCartMenu = false;
        localStorage.setItem(localStorageCartKey, "Close");
    }

    if(screen.width > 980 && canOpenCartMenu)
    {
        // Desktop
        if(cartMenuOpen)
        {
            const cartBody = document.getElementById('cartBody');
            const MOTO = document.getElementById('MOTOBanner');
            cartBody.style.display = 'block';
            MOTO.style.top = "-46px";

            let mainMenuHld = document.getElementById('MainContentHolder');
            mainMenuHld.style.position = `relative`;
            mainMenuHld.style.top = `-11px`;

            localStorage.setItem(localStorageCartKey, "Open");

            try {
                let shopfyEmbed = document.querySelectorAll('shopify-forms-embed')[0];
                let newsLetterSignUpHld = shopfyEmbed.shadowRoot.getElementById('app-embed');

                newsLetterSignUpHld.style.right = 'calc(9vw + var(--newsLetterSignUpHldRight))';
            } catch (e){}
        }else
        {
            forceCloseCartMenu(true);
        }

    }else if(canOpenCartMenu)
    {
        // Phone
        canOpenCartMenu = false;
        redirectPage('/cart');
    }

    if(canOpenCartMenu)
        document.body.classList.toggle('openCartSidemenu');

    fixPage();

    let openCartOffset = window.location.pathname != "/" ? "0px" : "-5px";
    openCartOffset = window.location.pathname != "/pages/categories" ? openCartOffset : "-5px";
    document.documentElement.style.setProperty("--mainHldForScaleTop", openCartOffset);
}

function forceOpenCart()
{
    if(!cartMenuOpen)
    {
        toggleCartMenu();
    }
}

function removeItemFromCartSide(productId, itemId)
{
    let QTYToSendCS = document.getElementById(`CartSideQtyJsRef${productId}`).value;

    $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: {
            id: itemId,
            quantity: 0 // Set quantity to 0 to remove the item
        },
        dataType: 'json',
        success: function() {
            let itemToDelCS = document.getElementsByClassName(`cartSideItem${productId}`)[0];
            itemToDelCS.remove();

            tickCart(false, QTYToSendCS);
            removeProductFromArray(productId);
            toggleCartEmptyState();
            updateCartSideSubTotal();
        }
    });
}

function changeQTYInCartSide(event, productId, prodIDToSend)
{
    let QTYToSendCS = event.target.value;
    let tickUpDown = false;
    let changeAmount = 0;

    if(ghostItemsInCart[productId].QTY < QTYToSendCS)
    {
        // Add
        tickUpDown = true;
        changeAmount = QTYToSendCS - ghostItemsInCart[productId].QTY;
    }else
    {
        // Remove
        changeAmount = ghostItemsInCart[productId].QTY - QTYToSendCS;
    }

    ghostItemsInCart[productId].QTY = QTYToSendCS;

    $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: {
            id: prodIDToSend,
            quantity: QTYToSendCS
        },
        dataType: 'json',
        success: function() {
            tickCart(tickUpDown, changeAmount);
            updateCartSideSubTotal();
        }
    });
}

function toggleCartEmptyState()
{
    let itemInSideCartCount = 0;
    for(var prop in ghostItemsInCart)
    {
        if (ghostItemsInCart.hasOwnProperty(prop))
        {
            itemInSideCartCount++;
        }
    }

    const emptyCartTextJS = document.getElementsByClassName('emptyCartText')[0];
    const emptyCartGoToCartJS = document.getElementsByClassName('cartSideFtrBtn')[0];
    const emptyCartClearCartJS = document.getElementsByClassName('cartSideFtrBtn')[1];
    const emptyCartSubtotalJS = document.getElementsByClassName('cartSideSubTotal')[0];
    const emptyCartCloseBTNJS = document.getElementsByClassName('cartSideCloseBTN')[0];
    if(itemInSideCartCount == 0)
    {
        // Empty Cart
        emptyCartTextJS.style.display = 'block';
        emptyCartClearCartJS.style.display = 'none';
        emptyCartSubtotalJS.style.display = 'none';
        emptyCartGoToCartJS.style.paddingTop = '29px';
        emptyCartCloseBTNJS.style.paddingTop = '12px';
    }else
    {
        // Items In Cart
        emptyCartTextJS.style.display = 'none';
        emptyCartClearCartJS.style.display = 'flex';
        emptyCartSubtotalJS.style.display = 'block';
        emptyCartGoToCartJS.style.paddingTop = '9.5px';
        emptyCartCloseBTNJS.style.paddingTop = '10px';
    }
}

function updateCartSideSubTotal()
{
    $.ajax({
        url: '/cart.js',
        dataType: 'json',
        success: function(cart) {
            // cart is the JSON objec
            let totalCents = cart.total_price;
            let totalDollars = (totalCents / 100).toFixed(2);
            let subTotalElm = document.getElementsByClassName('cartSideSubTotal')[0];

            subTotalElm.innerHTML = `<p>Subtotal: $${totalDollars}</p>`;
        }
    });
}

function fixCartMenuHeight()
{
    let cartSideHr = document.getElementsByClassName('cartSideHr');
    let cartSideItemHld = document.getElementsByClassName('cartSideItemHld')[0];
    let whiteSpaceCalc = cartSideHr[1].getBoundingClientRect().top - cartSideHr[0].getBoundingClientRect().top;

    cartSideItemHld.style.maxHeight = `${whiteSpaceCalc}px`;
}

let shouldBreakNewsletterCheck = false;
let newsletterOnScreen = false;

let checkAmount = 0;

const newsletterCheck = setInterval(() => {
    if(localStorage.getItem('cartMenuOpenStatus') === "Open")
    {
        try {
            let shopfyEmbed = document.querySelectorAll('shopify-forms-embed')[0];
            let newsLetterSignUpHld = shopfyEmbed.shadowRoot.getElementById('app-embed');

            newsLetterSignUpHld.style.right = 'calc(9vw + var(--newsLetterSignUpHldRight))';

            shouldBreakNewsletterCheck = true;
            newsletterOnScreen = true;
        } catch (e){}
    }else if(newsletterOnScreen)
    {
        shouldBreakNewsletterCheck = true;
    }else
    {
        try {
            let shopfyEmbed = document.querySelectorAll('shopify-forms-embed')[0];
            let newsLetterSignUpHld = shopfyEmbed.shadowRoot.getElementById('app-embed');

            shouldBreakNewsletterCheck = true;
            newsletterOnScreen = true;
        } catch (e){}
    }

    if(shouldBreakNewsletterCheck || checkAmount > 3000)
    {
        clearInterval(newsletterCheck);
    }
}, 5);

window.addEventListener("resize", function() {
    // Your function code here
    fixCartMenuHeight();

    if(cartMenuOpen && window.screen.width < 980)
    {
        forceCloseCartMenu();
    }
});

document.addEventListener("DOMContentLoaded", function() {
    if(localStorage.getItem('cartMenuOpenStatus') === "Open")
    {
        forceOpenCart();
    }
});

// General For Adding Products
let cartItemCounter = 0;
let isProductPageGloabal = false;
let productsAddedOn = [];

function addToCartThenListen(productId, ghostItemImgSrc, ghostItemTitle, ghostItemPrice, ghostItemURL, isProductPage = false, isRelatedProduct = false)
{
    isProductPageGloabal = isProductPageGloabal ? isProductPageGloabal : isProductPage;
    
    /*//Debug Tools Feel Free To Use Anytime // ? Made 11/25/25
    console.log(`-----------------------------------------------`);
    console.log(`Product Id: ${productId}`);
    console.log(`Image Src: ${ghostItemImgSrc}`);
    console.log(`Title: ${ghostItemTitle}`);
    console.log(`Price: ${ghostItemPrice}`);
    console.log(`URL: ${ghostItemURL}`);
    console.log(`Is Product Page: ${isProductPage}`);
    console.log(`Is Related Item: ${isRelatedProduct}`);
    console.log(`-----------------------------------------------`);
    // Used Again On 12/13/2025 Thanks you Past T Or Anyone Else Reading
    // Used on 03/25/2026 :D*/
    
    const cartNumberCounter = document.getElementById('hdrShoppingCartCountTextHolder');

    let idToUse = !isProductPage ? `#add-to-cart-form${productId}` : '#add-to-cart-form';
    idToUse = isRelatedProduct ? `#add-to-cart-form-RI${productId}` : idToUse;

    if(!productsAddedOn.includes(productId))
    {
        productsAddedOn.push(productId);
        $(idToUse).on('submit', function(event) {
            event.preventDefault(); // prevent default form submission
    
            $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: $(this).serialize(),
                dataType: 'json',
            success: function(data) {
                const newGhostItemId = data.id;
                addNewGhostProduct(productId, newGhostItemId, ghostItemImgSrc, ghostItemTitle, ghostItemPrice, ghostItemURL);
                }
            });
    
            let idToUse = isRelatedProduct ? `add-to-cart-button-RI${productId}` : `add-to-cart-button${productId}`;
            const element = document.getElementById(idToUse);
    
            var delayInMilliseconds = 750;
    
            setTimeout(function() {
                element.innerText = "Add To Cart";
                element.style.removeProperty('background-color');
                element.style.color = "var(--thirdColor)";
                element.style.transform = 'scale(1.0)';
                cartNumberCounter.style.transform = 'scale(1.0)';
    
                if(!isProductPage)
                {
                    element.style.removeProperty('font-size');
                }
            }, delayInMilliseconds);
        });
    }
}
function addToCartAnimation(productId, isRelatedProduct = false)
{
    ATCHit();
    const cartNumberCounter = document.getElementById('hdrShoppingCartCountTextHolder');
    // Try To Vibrate The Phone
    buzzPhone(75);

    const ItemQty =  document.getElementById("proItemQtyJsRef" + productId);
    let ItemQtyValue = 1;

    try {
        ItemQtyValue = ItemQty.value;
    } catch (e) {}

    if(parseInt(ItemQtyValue) <= 99 && Number.isInteger(Number(ItemQtyValue)))
    {
        if(screen.width > 500)
        {
            forceOpenCart();
        }

        let idToUse = isRelatedProduct ? `add-to-cart-button-RI${productId}` : `add-to-cart-button${productId}`;
        let fontSizeToSetBtn = screen.width >= 389 ? 18 : 15;

        tickCart(true,ItemQtyValue);
        const element = document.getElementById(idToUse);
        element.innerText = "Added To Cart";
        element.style.backgroundColor = "var(--ATCColor)";

        let scaleATCBtn = screen.width > 500 ? 1.05 : 1.025;
        
        element.style.transform = `scale(${scaleATCBtn})`;

        if(screen.width < 500)
        {
            cartNumberCounter.style.transform = 'scale(1.25)';
        }

        if (!isProductPageGloabal)
        {
            element.style.fontSize = `${fontSizeToSetBtn}px`;
        }
    }
}